import {api} from '../../contexts/AuthContext';
import type {
    GraderCurrentPrompt,
    GraderJudgeResponse,
    GraderJudgedUrl,
    GraderRunResponse,
    GraderRunSampleInput,
    GraderSampleResponse,
    GraderSampleUrl,
    GraderVerdict,
} from '../../types';

export type {
    GraderCurrentPrompt,
    GraderJudgeResponse,
    GraderJudgedUrl,
    GraderRunResponse,
    GraderRunSampleInput,
    GraderSampleResponse,
    GraderSampleUrl,
    GraderVerdict,
};

// Grader API (bd deepcontext-hhnxm). Admin prompt-eval playground, gated
// server-side to a single allowlisted email on top of requireAuth + requireAdmin.
// Read/run only — nothing here mutates a production prompt or writes results.

export const graderApi = {
    // GET /api/grader/current-prompt — live brand-safety template to seed the editor.
    getCurrentPrompt: async (): Promise<GraderCurrentPrompt> => {
        const response = await api.get('/api/grader/current-prompt');
        return response.data;
    },

    // GET /api/grader/prompts/:promptId/sample?n=N — N real scanned URLs + cached content.
    getSample: async (promptId: string, n?: number): Promise<GraderSampleResponse> => {
        const query = typeof n === 'number' ? `?n=${n}` : '';
        const response = await api.get(`/api/grader/prompts/${encodeURIComponent(promptId)}/sample${query}`);
        return response.data;
    },

    // POST /api/grader/run — run the edited prompt over a sample on Gemini flash-lite.
    run: async (body: {
        prompt: string;
        sample: GraderRunSampleInput[];
        promptId?: string;
        model?: string;
    }): Promise<GraderRunResponse> => {
        const response = await api.post('/api/grader/run', body);
        return response.data;
    },

    // POST /api/grader/judge — OpenAI judge scores the candidate verdicts 0-10 + reasoning.
    judge: async (body: {
        blueprint: string;
        verdicts: Array<GraderVerdict & { content?: string | null }>;
        judgeModel?: string;
    }): Promise<GraderJudgeResponse> => {
        const response = await api.post('/api/grader/judge', body);
        return response.data;
    },
};
